import { formatInTimeZone } from 'date-fns-tz';

export function getTimezoneOffset(timezone: string): string {
  const now = new Date();

  const localOffset = -now.getTimezoneOffset();

  const targetOffsetString = formatInTimeZone(now, timezone, 'xxx');
  const [targetSign, targetHours, targetMinutes] = (
    /([+-])(\d{2}):(\d{2})/.exec(targetOffsetString) ?? []
  ).slice(1);
  const targetOffset =
    (parseInt(targetHours) * 60 + parseInt(targetMinutes)) *
    (targetSign === '+' ? 1 : -1);

  const diffInMinutes = targetOffset - localOffset;

  const hours = Math.floor(Math.abs(diffInMinutes) / 60);
  const minutes = Math.abs(diffInMinutes) % 60;

  const sign = diffInMinutes >= 0 ? '+' : '-';

  if (hours === 0 && minutes === 0) {
    return `+0HR`;
  }

  if (hours === 0) {
    return `${sign}${String(minutes)}M`;
  }

  if (minutes === 0) {
    return `${sign}${String(hours)}HR`;
  }

  return `${sign}${String(hours)}HR ${String(minutes)}M`;
}
